var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoundSterling2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 5H6.75C6.75 7.62335 4.62335 9.75 2 9.75V14.25C4.62335 14.25 6.75 16.3766 6.75 19H17.25C17.25 16.3766 19.3766 14.25 22 14.25V9.75C19.3766 9.75 17.25 7.62335 17.25 5ZM13.3125 7.25C14.9459 7.25 16.25 8.59189 16.25 10.2222C16.25 10.6364 15.9142 10.9722 15.5 10.9722C15.0858 10.9722 14.75 10.6364 14.75 10.2222C14.75 9.39796 14.0953 8.75 13.3125 8.75C12.5297 8.75 11.875 9.39796 11.875 10.2222V11.6944H14.625C15.0392 11.6944 15.375 12.0302 15.375 12.4444C15.375 12.8587 15.0392 13.1944 14.625 13.1944H11.875V13.3333C11.875 14.0416 11.6611 14.7021 11.294 15.25H15.5C15.9142 15.25 16.25 15.5858 16.25 16C16.25 16.4142 15.9142 16.75 15.5 16.75H8.5C8.08579 16.75 7.75 16.4142 7.75 16C7.75 15.5858 8.08579 15.25 8.5 15.25C9.52444 15.25 10.375 14.4031 10.375 13.3333V13.1944H8.5C8.08579 13.1944 7.75 12.8587 7.75 12.4444C7.75 12.0302 8.08579 11.6944 8.5 11.6944H10.375V10.2222C10.375 8.59189 11.6791 7.25 13.3125 7.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 15.75C20.2051 15.75 18.75 17.2051 18.75 19H20C21.1046 19 22 18.1046 22 17V15.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 17V15.75C3.79493 15.75 5.25 17.2051 5.25 19H4C2.89543 19 2 18.1046 2 17Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 8.25V7C22 5.89543 21.1046 5 20 5H18.75C18.75 6.79493 20.2051 8.25 22 8.25Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 5H5.25C5.25 6.79493 3.79493 8.25 2 8.25V7C2 5.89543 2.89543 5 4 5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoundSterling2);
export default __webpack_public_path__ + "static/media/pound-sterling-2.136bd5b0542c7937379a27990e896b98.svg";
export { ForwardRef as ReactComponent };